module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('PlanoBanner', {
    attrs: {
      "status": _vm.status
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('header', [(!_vm.dense) ? _c('SystemTypeIcon', {
    staticClass: "pointer",
    attrs: {
      "type": _vm.item.template.systemType.id
    },
    on: {
      "click": _vm.openPlano
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('h1', {
    staticClass: "pointer",
    on: {
      "click": _vm.openPlano
    }
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.item.campaign.name) + " /// " + _vm._s(_vm.item.zone.name))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.item.height) + " x " + _vm._s(_vm.item.width))])])], 1), _vm._v(" "), (_vm.canAddToBasket) ? _c('AddToBasket', {
    attrs: {
      "id": "add2basket",
      "item": _vm.item
    }
  }) : _vm._e(), _vm._v(" "), _c('table', [_c('tbody', [(_vm.item.isLocked) ? _c('tr', [_c('Lock'), _vm._v(" "), _c('label', {
    staticClass: "lock"
  }, [_vm._v(_vm._s(_vm.item.lockedBy.initial) + " /// " + _vm._s(_vm.item.lockedAt))])], 1) : _vm._e(), _vm._v(" "), _c('tr', [_c('PopupMenu', [_c('td', {
    staticClass: "options"
  }, [_vm._v(_vm._s(_vm.$trad.planoList.option))]), _vm._v(" "), _c('ul', {
    slot: "items"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.$emit('showDuplicateModal', _vm.item);
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.planoList.duplicate))]), _vm._v(" "), (!_vm.item.isLocked) ? _c('hr') : _vm._e(), _vm._v(" "), (!_vm.item.isLocked) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.$emit('openEditNameModal', _vm.item, $event);
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.planoList.editName))]) : _vm._e(), _vm._v(" "), (!_vm.item.isLocked && _vm.hasAccessDelete('plano_builder')) ? _c('li', {
    on: {
      "click": _vm.deletePlano
    }
  }, [_vm._v(_vm._s(_vm.$trad.planoList.delete))]) : _vm._e(), _vm._v(" "), (!_vm.item.isLocked && _vm.hasAccessUpdate('plano_builder') && _vm.item.status === 'IN PROGRESS') ? _c('li', {
    on: {
      "click": function($event) {
        _vm.$emit('version', _vm.item.id, _vm.item.name);
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$trad.planoList.history) + "\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.workflows), function(action, index) {
    return _c('li', {
      key: index,
      style: ({
        backgroundColor: action.color,
        color: 'white'
      }),
      on: {
        "click": function($event) {
          _vm.$emit('changeStatusPlano', _vm.item.id, action, 'updateStatus');
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.$tradFor(action.terms.name)) + "\n                            ")])
  }), _vm._v(" "), (!_vm.item.isLocked) ? _c('li', {
    staticClass: "archive",
    on: {
      "click": function($event) {
        _vm.$emit('archivedPlano', _vm.item, 'updateArchive');
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.item.archived ? _vm.$trad.StatStatus.labelDesarchived : _vm.$trad.StatStatus.labelArchived) + "\n                            ")]) : _vm._e()], 2)])], 1), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "cell"
  }, [_vm._v("id " + _vm._s(_vm.item.id))]), _vm._v(" "), _c('span', {
    staticClass: "cell pointer",
    on: {
      "click": function($event) {
        _vm.$emit('modalComment', _vm.item.id);
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.item.nbComments) + " "), _c('i', {
    staticClass: "fa fa-comment"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('Status', {
    attrs: {
      "value": _vm.item.status
    }
  })], 1), _vm._v(" "), (!_vm.dense) ? _c('td', [_c('AuthorBadge', {
    attrs: {
      "label": "M",
      "author": _vm.item.modifiedUser.initial,
      "date": _vm.item.modifiedDate
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.dense) ? _c('td', [_c('AuthorBadge', {
    attrs: {
      "label": "C",
      "author": _vm.item.createdUser.initial,
      "date": _vm.item.createdAt
    }
  })], 1) : _vm._e()])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24e92a16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planoList/plano-list-item.vue
// module id = 3081
// module chunks = 0